import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import type { iSupplierBillPaymentReceipt } from "@sdk/supplier-bill-payment-receipts/supplier-bill-payment-receipt-model";
import React from "react";

const ViewSupplierPaymentReceiptModal = React.lazy(
  () => import("./view-supplier-payment-receipt-modal")
);

export type ViewSupplierPaymentReceiptModalState = {
  bookingId: string;
  productId: string;
  receipt: iSupplierBillPaymentReceipt;
  onSuccess?: () => void;
  accountingContext?: boolean;
};

const ViewSupplierPaymentReceipt: iModalProps<
  typeof ViewSupplierPaymentReceiptModal,
  ViewSupplierPaymentReceiptModalState
> = {
  name: "view-supplier-payment-receipt",
  component: GenerateModalWithSuspense(ViewSupplierPaymentReceiptModal),
};

export default ViewSupplierPaymentReceipt;
